<div class="container p-0" [class.fade-in]="state === 'open'" [class.fade-out]="state === 'void'">
  <div class="row header">
    <vitamui-common-search-bar
      #searchBar
      class="col-5 mr-2"
      name="element-search"
      (searchChanged)="onSearch($event)"
      (clear)="resetSearch()"
      placeholder="{{ 'MENU.GRAB_APPLICATION' | translate }}"
    ></vitamui-common-search-bar>

    <vitamui-common-item-select
      class="col-3 p-0 ml-5"
      [label]="'SELECT_TENANT.SELECT' | translate"
      [selectedLabel]="'SELECT_TENANT.SELECTED' | translate"
      [items]="tenants"
      [selectedItem]="selectedTenant"
      (itemSelected)="updateApps($event)"
      appearance="outline"
    ></vitamui-common-item-select>

    <div class="apps-container col-3 ml-auto" (click)="close()">
      <span class="pr-2">{{ 'MENU.MY_APPLICATIONS' | translate }}</span>
      <button mat-icon-button class="apps-button">
        <i class="vitamui-icon vitamui-icon-apps-colored"
          ><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span
          ><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span
          ><span class="path9"></span
        ></i>
      </button>
    </div>
  </div>

  <div class="pt-4">
    @if (filteredApplications) {
      <span class="px-3">{{ 'MENU.RESULT' | translate }}&nbsp;: </span>
      <hr class="mb-0" />
      <mat-selection-list
        id="searchResults"
        (selectionChange)="navigateToApplication($event)"
        class="py-3 overflow"
        [multiple]="false"
        [hideSingleSelectionIndicator]="true"
      >
        @for (app of filteredApplications; track app) {
          <mat-list-option [value]="app">
            <vitamui-common-menu-application-tile
              [application]="app"
              [applicationUrl]="getApplicationUrl(app)"
              [hlCriteria]="criteria"
            ></vitamui-common-menu-application-tile>
          </mat-list-option>
        }
      </mat-selection-list>
    } @else {
      <mat-tab-group
        animationDuration="300ms"
        mat-align-tabs="start"
        [selectedIndex]="tabSelectedIndex"
        (selectedTabChange)="changeTabFocus($event)"
      >
        @for (element of appMap | keyvalue; track element) {
          <mat-tab [label]="'MENU.' + element.key.identifier | translate: { default: element.key.title }">
            <mat-selection-list
              (selectionChange)="navigateToApplication($event)"
              class="py-3"
              [multiple]="false"
              [hideSingleSelectionIndicator]="true"
            >
              @for (app of element.value; track app) {
                <mat-list-option cdkTrapFocus cdkTrapFocusAutoChange [value]="app">
                  <vitamui-common-menu-application-tile
                    [application]="app"
                    [applicationUrl]="getApplicationUrl(app)"
                  ></vitamui-common-menu-application-tile>
                </mat-list-option>
              }
            </mat-selection-list>
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>
</div>
